module.exports = __webpack_public_path__ + "r-v3/img/ico_resetSticker_white.0d89a787.svg";